import { dominosStore } from '../../../main';
import { getConfig } from '../../../modules/AppMain/config';
import { InsiderProduct } from '../../../types/insiderProduct';
import { goFish } from '../../global/api';
import { CartStore } from '../../global/store/CartStore';
import { createProductUrl } from '../productUrl';
import { checkIfProdIsPackage } from '../checkIfProdIsPackage';

interface Params {
    products: AppCartProduct[];
    localguid: string;
}

export const prepareProductsForInsider = async ({ products, localguid }: Params) => {
    const { routes } = getConfig();

    const cart = dominosStore.cartStore;
    try {
        // Retrieve the products to extract images and taxonomy. Don't returns packings. Make sure to check if they are from the cache.
        const allProductsFromCache = await goFish({
            api: 'getproductlist',
            data: { localguid }
        }).then((response: ProductsList) => {
            if (response.Status) {
                return response.Product || [];
            } else {
                return [];
            }
        });

        const insiderProducts: InsiderProduct[] = [];

        products
            .filter(prod => !checkIfProdIsPackage(cart, prod))
            .forEach(({ Data, Type }) => {
                const matchedProduct = (allProductsFromCache || []).find(p => p.Id === Data.Id);

                if (!matchedProduct) {
                    // Fallback for promotions/coupons that may not be present in getproductlist.
                    const fallbackProduct: InsiderProduct = {
                        id: (Data as any).UId || Data.Id,
                        name: Data.Name,
                        taxonomy: Type === 2 ? ['Promocje'] : [],
                        unit_price: Data.Price || 0.00001,
                        unit_sale_price: Data.Price || 0.00001,
                        url: origin,
                        product_image_url: origin,
                        quantity: Data.Count || 1
                    };
                    insiderProducts.push(fallbackProduct);
                    return;
                }

                const sortedImages =
                    matchedProduct?.Image?.sort((a, b) => a.Breakpoint + b.Breakpoint) ?? [];

                const firstImageSrc = sortedImages[0]?.Src;

                const productUrl = createProductUrl({
                    productType: Type,
                    categoryUrl: matchedProduct.CategoryUrl,
                    prodId: Data.Id,
                    routes
                });
                
                const product = {
                    id: (Data as any).UId || Data.Id,
                    name: Data.Name,
                    taxonomy: matchedProduct?.CategoryName ? [matchedProduct.CategoryName] : [],
                    // promotion, configurator and creator has zero price but we can't send it to insider so we send 0.00001
                    unit_price: Data.Price || 0.00001,
                    unit_sale_price: Data.Price || 0.00001,
                    url: productUrl,
                    product_image_url: firstImageSrc ? origin + firstImageSrc : origin,
                    quantity: Data.Count,
                    stock: 100000,
                    color: "'N/A",
                    size: "'N/A"
                };
                insiderProducts.push(product);
            });
        return insiderProducts;
    } catch (e) {
        console.error(e);
        return [];
    }
};
